import React from 'react';
import AnimatedText4 from './AnimatedText4';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import AnimatedText1 from './AnimatedText1';
import AnimatedText2 from './AnimatedText2';
import AnimatedText3 from './AnimatedText3';
import AnimatedText5 from './AnimatedText5';
import AnimatedText6 from './AnimatedText6';
import AnimatedText7 from './AnimatedText7';
import AnimatedText8 from './AnimatedText8';
gsap.registerPlugin(useGSAP);
const animationMap = {
  1: AnimatedText1,
  2: AnimatedText2,
  3: AnimatedText3,
  4: AnimatedText4,
  5: AnimatedText5,
  6: AnimatedText6,
  7: AnimatedText7,
  8: AnimatedText8,
};

function AnimatedText({ animation, text, id }) {
  const AnimationComponent = React.useMemo(() => {
    const id = (animation || {}).type || 1;
    return animationMap[id] || AnimatedText1;
  }, [animation?.type]);

  return <AnimationComponent setting={animation} text={text} id={id} />;
}

export default AnimatedText;
